import EntryDetails from './EntryDetails';

export default EntryDetails;
